import { defineStore } from 'pinia'
import { type Ref, ref, watchEffect } from 'vue'
import useValidate from '@/shared/lib/validate'
import { useLoadDependenciesCircleForLineObjects } from './../model/api.ts'

export const useInventLineCreateModal = defineStore('invent_line_create_modal', () => {
  const { required } = useValidate()

  const open = ref(false)

  const pointCoords = ref<number[]>([0, 0])
  const currentObject = ref<number | null>(null)

  const objectList = ref<{ title: string; value: number }[]>([])
  const coordsList = ref<{ [key: number]: any[] }>({})
  const childObjects = ref<number[]>([])

  let resolvePromise: ((value: any) => void) | null = null
  let rejectPromise: ((reason?: any) => void) | null = null

  const rules = {
    currentObject: [(value: number) => required(value)],
  }

  /**
   * Функция показа модального окна
   */
  const show = (coords: any[]): Promise<{ coords: any[]; children: number[] }> => {
    open.value = true
    pointCoords.value = coords

    return new Promise<{ coords: any[]; children: number[] }>((resolve, reject) => {
      resolvePromise = resolve
      rejectPromise = reject
    })
  }

  /**
   * Функция подтверждения модального окна
   */
  const confirm = () => {
    open.value = false

    if (resolvePromise) {
      const current = Number(currentObject.value)
      childObjects.value.push(current)

      const sendData = {
        coords: coordsList.value[current],
        children: childObjects.value,
      }

      resolvePromise(sendData)
      clearPromise()
    }
  }

  /**
   * Функция отмены модального окна
   */
  const cancel = () => {
    open.value = false

    if (rejectPromise) {
      rejectPromise()
      clearPromise()
    }
  }

  /**
   * Функция загрузки данных
   * @param objectId
   * @param filter
   */
  const loadData = (objectId: Ref<number>, filter: Ref<any>) => {
    const result = useLoadDependenciesCircleForLineObjects(objectId, filter)

    watchEffect(() => {
      if (result.data.value) {
        objectList.value = []

        result.data.value.data.forEach((item: any) => {
          coordsList.value[item.id] = item.coordinates

          objectList.value.push({
            title: `[${item.object_type.object_name}] ${item.name}`,
            value: item.id,
          })
        })
      }
    })

    return result
  }

  /**
   * Функция очистки promise
   */
  const clearPromise = () => {
    resolvePromise = null
    rejectPromise = null
    pointCoords.value = [0, 0]
    currentObject.value = null

    if (childObjects.value.length == 2) {
      childObjects.value = []
    }
  }

  return {
    childObjects,
    pointCoords,
    currentObject,
    rules,
    objectList,

    open,
    show,
    confirm,
    cancel,
    loadData,
  }
})
